import {
    AppointmentOverview,
    Title,
    DateTimePicker,
    PersonalDataForm,
    Remark,
    ServiceCenterPicker,
    VehicleDataForm,
  } from '@/components';

  import {
    isValidChassie,
  } from '@/utils';

  import router from '@/router';

  import validationFlow from '@/validation-flow';

  import {
    mapActions,
    mapGetters,
    mapMutations,
  } from 'vuex';

  export default {
    name: 'step1Maintenance',
    components: {
      VehicleDataForm,
      PersonalDataForm,
      DateTimePicker,
      ServiceCenterPicker,
      AppointmentOverview,
      [AppointmentOverview.name]: AppointmentOverview,
      [Title.name]: Title,
      [DateTimePicker.name]: DateTimePicker,
      [PersonalDataForm.name]: PersonalDataForm,
      [Remark.name]: Remark,
      [ServiceCenterPicker.name]: ServiceCenterPicker,
      [VehicleDataForm.name]: VehicleDataForm,
    },
    props: {},
    data: () => ({
      isLoading: false,
    }),
    computed: {
      ...mapGetters('appointment', {
        customerDataRaw: 'getCustomerDataRaw',
        chassie: 'getChassie',
        loadingState: 'getLoadingState',
        isValidAppointment: 'getIsValidAppointment',
        appointmentPostObject: 'getAppointmentPostObject',
      }),
      isConfirmAppointmentDisabled() {
        return this.loadingState || !this.isValidAppointment || !isValidChassie(this.chassie);
      },
    },
    methods: {
      ...mapActions('appointment', {
        setAppointment: 'SET_APPOINTMENT',
      }),
      ...mapMutations('appointment', {
        setCat: 'SET_CAT',
      }),
      goToPreviousStep() {
        this.$router.push({
          name: 'step3ServiceType',
        });
      },
      confirmAppointment() {
        if (this.isConfirmAppointmentDisabled) {
          return;
        }

        const personalDataForm = this.$refs.personalDataForm.$refs.form;
        const personalDataFormTitle = this.$refs.personalDataForm.$refs.formPersonalDataTitle;
        const validPersonalDataFormTitle = personalDataFormTitle.isValid();

        const vehicleDataForm = this.$refs.vehicleDataForm.$refs.form;

        Promise.all([
          personalDataForm.validate(),
          vehicleDataForm.validate(),
        ]).then(([isValidPersonalForm, isValidVehicleForm]) => {
          if (isValidPersonalForm && isValidVehicleForm) {
            if (this.isValidAppointment && validPersonalDataFormTitle && !this.loadingState) {
              this.setCat('depot');
              this.setAppointment(this.appointmentPostObject)
                .then(() => {
                  validationFlow.validateStep1Maintenance();
                })
                .catch(() => {
                  router.push({
                    name: 'error',
                  });
                });
            }
          }
        });
      },
    },
  };
